/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 21:33:18
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-16 23:35:32
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/PopReminder/index.tsx
 */
import React from 'react';

import css from './css.less';

import { PopOver as Popover } from 'src/components/Antd';

const PopReminder = (props) => {
  const { title, content, children, visible, setVisible, placement, id } =
    props;

  return (
    <Popover
      id={id}
      overlayClassName={css.overlay}
      overlay={content}
      title={title}
      trigger='click'
      visible={visible}
      placement={placement}
      onVisibleChange={setVisible}>
      {children}
    </Popover>
  );
};
export default PopReminder;
